<template>
  <div class="kitchen-management">
    <!-- 添加成员区域（横排） -->
    <div class="add-member-box">
      <div class="add-member-title">➕ 添加厨房成员</div>
      <div class="add-member-form">
        
        <input
          v-model="addForm.Desheopenid"
          type="text"
          placeholder="厨房主人OpenID"
          class="add-input"
        /><input
          v-model="addForm.openid"
          type="text"
          placeholder="成员OpenID"
          class="add-input"
        />
        <button class="btn btn-success" @click="addMember" :disabled="adding">
          {{ adding ? "添加中..." : "确定添加" }}
        </button>
      </div>
    </div>
    <!-- 搜索区域 -->
    <div class="search-box">
      <input
        v-model="searchForm.keyword"
        type="text"
        placeholder="厨房主人OpenID"
        class="search-input"
        @keyup.enter="getList"
      />
      <input
        v-model="searchForm.openid"
        type="text"
        placeholder="搜索成员OpenID"
        class="search-input"
        @keyup.enter="getList"
      />
      <button class="btn btn-primary" @click="getList" :disabled="loading">
        {{ loading ? "加载中..." : "搜索" }}
      </button>
      <button class="btn btn-default" @click="resetSearch">重置</button>
    </div>

    <!-- 表格 -->
    <div class="table-box">
      <div v-if="loading" class="loading-mask">
        <div class="loading-spinner"></div>
      </div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>主人头像</th>
              <th>主人昵称</th>
              <th>厨房主人OpenID</th>
              <th>成员OpenID</th>
              <th>加入时间</th>
              <th>管理员权限</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in tableData" :key="item.id">
              <td>{{ item.id }}</td>
              <td class="image-cell">
                <img
                  v-if="item.avatar"
                  :src="item.avatar"
                  class="avatar-image"
                  @error="handleImageError(item)"
                />
                <span v-else class="no-image">无</span>
              </td>
              <td class="ellipsis" :title="item.nickname">
                {{ item.nickname || "-" }}
              </td>
              
              <td class="openid-cell">
                <span class="openid-text ellipsis" :title="item.Desheopenid">{{
                  item.Desheopenid
                }}</span>
                <button
                  class="copy-btn"
                  @click="copyOpenId(item.Desheopenid)"
                  title="复制"
                >
                  <svg viewBox="0 0 24 24" width="14" height="14">
                    <path
                      fill="currentColor"
                      d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                    />
                  </svg>
                </button>
              </td>
              <td class="openid-cell">
                <span class="openid-text ellipsis" :title="item.openid">{{
                  item.openid
                }}</span>
                <button
                  class="copy-btn"
                  @click="copyOpenId(item.openid)"
                  title="复制"
                >
                  <svg viewBox="0 0 24 24" width="14" height="14">
                    <path
                      fill="currentColor"
                      d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                    />
                  </svg>
                </button>
              </td>
              <td>{{ formatDate(item.created_at) }}</td>
              <td>
                <span
                  :class="[
                    'status-tag',
                    item.is_admin ? 'status-success' : 'status-info',
                  ]"
                >
                  {{ item.is_admin ? "是管理员" : "普通成员" }}
                </span>
              </td>
              <td>
                <button
                  @click="setAdmin(item.id, item.is_admin ? 0 : 1)"
                  class="btn btn-sm"
                  :class="item.is_admin ? 'btn-default' : 'btn-primary'"
                >
                  {{ item.is_admin ? "取消管理员" : "设为管理员" }}
                </button>
                <button
                  @click="deleteMember(item.id)"
                  class="btn btn-sm btn-danger"
                  style="margin-left: 6px"
                >
                  移除
                </button>
              </td>
            </tr>
            <tr v-if="tableData.length === 0 && !loading">
              <td colspan="8" class="empty-data">暂无厨房成员</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <div class="pagination-info">共 {{ total }} 条</div>
        <div class="pagination-controls">
          <select
            v-model="pageSize"
            @change="handleSizeChange(pageSize)"
            class="page-size-select"
          >
            <option :value="10">10条/页</option>
            <option :value="20">20条/页</option>
            <option :value="50">50条/页</option>
            <option :value="100">100条/页</option>
          </select>
          <button
            class="page-btn"
            @click="handleCurrentChange(1)"
            :disabled="page === 1"
          >
            首页
          </button>
          <button
            class="page-btn"
            @click="handleCurrentChange(page - 1)"
            :disabled="page === 1"
          >
            上一页
          </button>
          <span class="page-info">第 {{ page }} / {{ totalPages }} 页</span>
          <button
            class="page-btn"
            @click="handleCurrentChange(page + 1)"
            :disabled="page === totalPages"
          >
            下一页
          </button>
          <button
            class="page-btn"
            @click="handleCurrentChange(totalPages)"
            :disabled="page === totalPages"
          >
            尾页
          </button>
          <div class="page-jumper">
            <span>跳至</span>
            <input
              type="number"
              v-model.number="jumpPage"
              @keyup.enter="handleJumpPage"
              class="jump-input"
            />
            <span>页</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 复制提示 -->
    <div v-if="copyTipVisible" class="copy-tip">{{ copyTipMessage }}</div>
  </div>
</template>

<script>
/* eslint-disable */
import {
  getKitchenMembers,
  removeKitchenMember,
  setKitchenAdmin,
  addKitchenMember,
} from "@/api/houtai";

export default {
  name: "KitchenIndex",
  data() {
    return {
      searchForm: { keyword: "", openid: "" },
      page: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      loading: false,
      jumpPage: 1,
      copyTipVisible: false,
      copyTipMessage: "",
      copyTipTimer: null,
      imageErrors: {},
      // 添加成员相关
      adding: false,
      addForm: {
        openid: "",
        Desheopenid: "",
        is_admin: 0,
      },
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
  },
  created() {
    this.getList();
  },
  beforeUnmount() {
    clearTimeout(this.copyTipTimer);
  },
  methods: {
    async getList() {
      let validPage = Math.max(1, parseInt(this.page) || 1);
      let validPageSize = Math.min(
        100,
        Math.max(10, parseInt(this.pageSize) || 20)
      );
      this.page = validPage;
      this.pageSize = validPageSize;
      this.loading = true;

      try {
        const params = { page: validPage, pageSize: validPageSize };
        if (this.searchForm.keyword) params.keyword = this.searchForm.keyword;
        if (this.searchForm.openid) params.openid = this.searchForm.openid;

        const res = await getKitchenMembers(params);
        if (res?.status === 200) {
          this.tableData = res.data || [];
          this.total = res.total || 0;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    handleSizeChange(size) {
      this.pageSize = parseInt(size);
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.page = Math.max(1, Math.min(page, this.totalPages));
      this.getList();
    },
    handleJumpPage() {
      this.handleCurrentChange(this.jumpPage);
    },
    resetSearch() {
      this.searchForm = { keyword: "", openid: "" };
      this.page = 1;
      this.pageSize = 20;
      this.getList();
    },

    // 添加成员
    async addMember() {
      // 表单验证
      if (!this.addForm.openid.trim()) {
        this.showCopyTip("❌ 请输入厨房主人OpenID");
        return;
      }
      if (!this.addForm.Desheopenid.trim()) {
        this.showCopyTip("❌ 请输入成员OpenID");
        return;
      }

      this.adding = true;
      try {
        const res = await addKitchenMember({
          openid: this.addForm.openid.trim(),
          Desheopenid: this.addForm.Desheopenid.trim(),
          is_admin: this.addForm.is_admin,
        });

        if (res?.status === 200) {
          this.showCopyTip("✅ 添加成员成功");
          // 清空表单
          this.addForm = {
            openid: "",
            Desheopenid: "",
            is_admin: 0,
          };
          this.getList(); // 刷新列表
        } else {
          this.showCopyTip(res?.msg || "❌ 添加失败");
        }
      } catch (err) {
        console.error("添加成员失败:", err);
        this.showCopyTip("❌ 添加失败，请检查网络或联系管理员");
      } finally {
        this.adding = false;
      }
    },

    // 设置管理员
    async setAdmin(id, is_admin) {
      if (!confirm("确定要修改权限吗？")) return;
      try {
        await setKitchenAdmin({ id, is_admin });
        this.showCopyTip(is_admin ? "✅ 设置管理员成功" : "✅ 取消管理员成功");
        this.getList();
      } catch (e) {
        this.showCopyTip("❌ 操作失败");
      }
    },

    // 删除成员
    async deleteMember(id) {
      if (!confirm("确定要移除此成员吗？")) return;
      try {
        await removeKitchenMember({ id });
        this.showCopyTip("✅ 移除成功");
        this.getList();
      } catch (e) {
        this.showCopyTip("❌ 移除失败");
      }
    },

    async copyOpenId(openid) {
      if (!openid) return;
      try {
        await navigator.clipboard.writeText(openid);
        this.showCopyTip("✅ OpenID复制成功");
      } catch {
        this.showCopyTip("❌ 复制失败");
      }
    },
    showCopyTip(msg) {
      clearTimeout(this.copyTipTimer);
      this.copyTipMessage = msg;
      this.copyTipVisible = true;
      this.copyTipTimer = setTimeout(() => {
        this.copyTipVisible = false;
      }, 2000);
    },
    handleImageError(item) {
      this.$set(this.imageErrors, item.id, true);
    },
    formatDate(t) {
      if (!t) return "-";
      const d = new Date(t);
      return d.toLocaleString();
    },
  },
};
</script>

<style scoped>
.kitchen-management {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 80px);
}
.search-box {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

/* 添加成员区域样式 */
.add-member-box {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #e6f7e6;
  background: #f9fff9;
}
.add-member-title {
  font-size: 14px;
  font-weight: 600;
  color: #67c23a;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e6f7e6;
}
.add-member-form {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}
.add-input {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 280px;
  outline: none;
}
.add-input:focus {
  border-color: #67c23a;
}


.search-input {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 240px;
  outline: none;
}
.search-input:focus {
  border-color: #409eff;
}
.btn {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
.btn-sm {
  padding: 4px 10px;
  font-size: 12px;
}
.btn-primary {
  background: #409eff;
  color: #fff;
  border: none;
}
.btn-default {
  border: 1px solid #dcdfe6;
}
.btn-danger {
  background: #f56c6c;
  color: #fff;
  border: none;
}
.btn-success {
  background: #67c23a;
  color: #fff;
  border: none;
}
.btn-success:hover {
  background: #85ce61;
}
.table-box {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  position: relative;
}
.table-wrapper {
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.data-table th,
.data-table td {
  border: 1px solid #ebeef5;
  padding: 12px 8px;
  text-align: left;
}
.data-table th {
  background: #f5f7fa;
  font-weight: 600;
}
.data-table tr:hover {
  background: #f9f9f9;
}
.ellipsis {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.image-cell {
  text-align: center;
}
.avatar-image {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  object-fit: cover;
}
.no-image {
  font-size: 12px;
  color: #ccc;
}

.copy-btn {
  border: 1px solid #dcdfe6;
  background: none;
  padding: 3px;
  border-radius: 3px;
  cursor: pointer;
  color: #999;
  float: right;
}
.copy-btn:hover {
  color: #409eff;
  border-color: #409eff;
}
.status-tag {
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 12px;
}
.status-success {
  background: #e6f7e6;
  color: #009900;
}
.status-info {
  background: #f4f4f5;
  color: #909399;
}
.empty-data {
  text-align: center;
  padding: 40px 0;
  color: #999;
}
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #f3f3f3;
  border-top-color: #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.pagination-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}
.page-size-select,
.page-btn,
.jump-input {
  padding: 6px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.page-btn {
  cursor: pointer;
}
.page-btn:disabled {
  opacity: 0.5;
}
.page-jumper {
  display: flex;
  align-items: center;
  gap: 4px;
}
.jump-input {
  width: 60px;
  text-align: center;
}
.copy-tip {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 10px 16px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
}
</style>